import { render, staticRenderFns } from "./LPTemp4.vue?vue&type=template&id=2880c5dd&scoped=true&"
import script from "./LPTemp4.vue?vue&type=script&lang=js&"
export * from "./LPTemp4.vue?vue&type=script&lang=js&"
import style0 from "./LPTemp4.vue?vue&type=style&index=0&id=2880c5dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2880c5dd",
  null
  
)

export default component.exports